import React from 'react';
import distintivoQ from '../../assets/partner/distintivoQ.png'
import ecuador_blanco from '../../assets/partner/ecuador_blanco.png'
import SmartPlanetBlanco from '../../assets/partner/SmartPlanetBlanco.png'
import TMLA from '../../assets/partner/TMLA.png'
import ahk from '../../assets/partner/AHK-EC.png'
import lata from '../../assets/partner/LATA-logo.png'


const Partners = () => {
    return (
        <>
            <div className=''>
                <h2 className='font-bold text-[30px] md:text-[55px] text-[#2e6a82] uppercase text-shadow-lg'>Our Partners &</h2>
                <h2 style={{ fontFamily: 'BloomingHeart' }} className='text-amber-500 text-[50px] md:text-[80px] mt-[-25px] md:mt-[-50px]'>Memberships</h2>
            </div>
            <div className="stats flex flex-col md:flex-row bg-gradient-to-b from-[#051937] to-[#004d7a] shadow w-full min-h-full items-center justify-center gap-4 p-4">
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={distintivoQ} alt="" />
                </div>
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={SmartPlanetBlanco} alt="" />
                </div>
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={TMLA} alt="" />
                </div>
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={lata} alt="" />
                </div>
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={ahk} alt="" />
                </div>
                <div className="stat flex justify-center items-center">
                    <img className="w-32 h-32 object-contain" src={ecuador_blanco} alt="" />
                </div>
            </div>
        </>

    );
};

export default Partners;